<template>

  <div class="full-width">

    <!-- //TITLE MOBILE -->
    <div class="header mobile"  v-if="isMobile">
      <h1>{{general.challengeTitle}}</h1>
      <b-button class="bt-challenges"  @click="showModal"  ref="btnShowMobile" >{{general.challengeBtPopupMobile}}</b-button>      
    </div>
    <!-- //TITLE MOBILE -->

    <!-- CONTENT -->
    <div class="block__sidebar content__challenges">

      <!-- //TITLE DESKTOP -->
      <div class="header desktop">
        <h1>{{general.challengeTitle}}</h1>
<!--        <b-button class="bt-challenges" @click="showModal" ref="btnShow">{{general.challengeBtPopupDesktop}}</b-button>-->
      </div>
      <!-- //TITLE DESKTOP -->

      <!-- //SUBTITLE DESKTOP -->
      <div class="header-sub desktop" v-if="!isMobile">
          <div class="entete title nmtop">
            <p>{{general.challengeSubTitle}}</p>
          </div>        
        <b-button class="btn btn-blue" :to="{ name: 'challenges-concours'}" >{{general.formBtSeeAll}}</b-button>
      </div>
      <!-- //SUBTITLE DESKTOP -->

      <!-- cards DESKTOP-->
      <div class="desktop">
        <b-row class="cards ">
          <template v-if="showLastContest">
            <b-col sm="12" lg='6' v-for="contest in lastContests" :key="contest.id" class="mb-4">
              <cardChallengesPicture
                  :subtitle = "'Jeu concours'"
                  :title = contest.title
                  :ranking = "'Classement'"
                  :rankingNumber = contest.totalRank
                  :rankingPrevious = contest.previousRank
                  :rank = contest.rank
                  :score = "'Score'"
                  :scoreNumber = contest.score
                  :target = contest.target
                  :img = contest.challengeMedia
                  :isLoad.sync = isLoading
                  link =  "accueil"
              />
            </b-col>
          </template>
          <b-col sm="12" lg='6' v-if="showLastChallenge">
            <cardChallengesDate
            :id = lastChallengeLoad.id
            :title = lastChallengeLoad.criteria
            :subtitle = lastChallengeLoad.criteria
            :startDate =  lastChallengeLoad.startDate
            :endDate = lastChallengeLoad.endDate
            :objectiveNumber = lastChallengeLoad.objective
            :inprogress = lastChallengeLoad.score
            :state = lastChallengeLoad.target
            :isLoad.sync = isLoading
            />
          </b-col>
        </b-row>
      </div>
      <!-- cards DESKTOP-->

      <!-- cardChallengesCommercials DESKTOP-->
      <div class="desktop" v-if="showLastChallengesCommercialsOne || showLastChallengesCommercialsTwo">
        <b-row class="block__cardChallengesCommercials">
          <b-col sm="12">
            <div class="header-sub">
                <div class="entete title">
                  <p>{{general.challengeSubTitleCommercial}}</p>
                </div>  
                <b-button class="btn btn-blue" :to="{ name: 'challenges-commercials'}" >{{general.formBtSeeAll}}</b-button>
            </div>
          </b-col>
            <b-col sm="12" lg='6' class="item"  v-if="showLastChallengesCommercialsOne">
              <cardChallengesCommercials
              :id = lastChallengesCommercialsLoad[0].id
              :title = "lastChallengesCommercialsLoad[0].user ? lastChallengesCommercialsLoad[0].user.fullName : ''"
              :subtitle = lastChallengesCommercialsLoad[0].criteria
              :startDate = lastChallengesCommercialsLoad[0].startDate
              :endDate = lastChallengesCommercialsLoad[0].endDate
              :objectiveNumber = lastChallengesCommercialsLoad[0].objective
              :inprogress = lastChallengesCommercialsLoad[0].score
              :state = lastChallengesCommercialsLoad[0].target
              :isLoad.sync = isLoading
              />
            </b-col>
            <b-col sm="12" lg='6' class="item"  v-if="showLastChallengesCommercialsTwo">
              <cardChallengesCommercials
              :id = lastChallengesCommercialsLoad[1].id
              :title = "lastChallengesCommercialsLoad[1].user ? lastChallengesCommercialsLoad[0].user.fullName : ''"
              :subtitle = lastChallengesCommercialsLoad[1].criteria
              :startDate = lastChallengesCommercialsLoad[1].startDate
              :endDate = lastChallengesCommercialsLoad[1].endDate
              :objectiveNumber = lastChallengesCommercialsLoad[1].objective
              :inprogress = lastChallengesCommercialsLoad[1].score
              :state = lastChallengesCommercialsLoad[1].target
              :isLoad.sync = isLoading
              />
            </b-col>
        </b-row>      
      </div>
      <!-- cardChallengesCommercials DESKTOP-->

      <!-- FORM CHALLENGE -->
      <formChallenge @reload="reload()"> </formChallenge>

      <!-- Reglements modal -->
      <reglementsModal v-if="currentType !== 'CONFIG_AGENT'"> </reglementsModal>

      <!-- SIDEBAR -->
      <SidebarChallenges :mobile="true" class="mobile"  v-if="isMobile"/>

    </div>
    <!-- CONTENT -->

    



    <!-- Popup LAWS IF MOBILE OR NOT -->
    <ChallengesLaws v-if="isMobile" :class="{hide:hideLaws}" v-on:modalaccepted="hideModalLaws"></ChallengesLaws>
    
    <b-modal 
      id="laws" 
      modal-class='modal-laws'
      :hide-header=true
      :hide-footer=true
      :no-close-on-backdrop=true
      :no-close-on-esc=true
      top 
      v-if="!isMobile"
      >
      <ChallengesLaws v-on:modalaccepted="hideModalLaws"></ChallengesLaws>

    </b-modal>
    <!-- Popup LAWS IF MOBILE OR NOT -->




    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->
      <transition name="slide">
        <keep-alive>
          <router-view class="transition"></router-view>
        </keep-alive>
      </transition>
    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->

    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->
    <transition name="modal"> 
      <keep-alive>
        <router-view name="helper" class="myModal"></router-view>
      </keep-alive>
    </transition>    
    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->

  </div>


</template>


<script>
import { mapGetters } from 'vuex'
import cardChallengesPicture from '../../../module/card/CardChallengesPicture'
import cardChallengesDate from '../../../module/card/CardChallengesDate'
import cardChallengesCommercials from '../../../module/card/CardChallengesCommercials'
import formChallenge from '../../../module/modal/FormChallenge'
import reglementsModal from '../../../module/modal/ReglementsModal'
import ChallengesLaws from '../challenges/ChallengesLaws'
import SidebarChallenges from '../../../module/sidebar/SidebarChallenges'
import ChallengesMixin from '../challenges/ChallengesMixin'
import ApiService from '../../../../services/ApiService'
import ApiAuthenticationService from '../../../../services/ApiAuthenticationService'
import ApiAuthentificationService from "@/services/ApiAuthenticationService";


export default {
  name:"challengesHome",
    components:{
      cardChallengesPicture,
      cardChallengesDate,
      cardChallengesCommercials,
      formChallenge,
      reglementsModal,
      SidebarChallenges,
      ChallengesLaws,
    }, 
    mixins: [
      ChallengesMixin
    ],    
    computed: {
      ...mapGetters([
        'getBrowse',
        'getGeneral',
        'getChallengeSelected'
      ])
    },
    data () {
      return {
        content:"",
        formContent:"",
        general:'',
        isMobile:false,
        hideLaws:true,
        lastContest:{},
        lastContests: {},
        theMedia:'',
        lastChallengeLoad:{},
        cardChallengeMedia:'',
        lastChallengesCommercialsLoad:[{},{}],
        showLastChallenge:true,
        showLastChallengesCommercialsOne:null,
        showLastChallengesCommercialsTwo:null,
        showLastContest:true,
        currentType:null
      }
    },
    created (){
      this.content = this.getBrowse;
      this.general = this.getGeneral;
      this.currentType = ApiAuthenticationService.getCurrentUser().type;
      this.getData().then(() => this.isLoading = false);
      this.getModal();
    },
    mounted() {
      this.$store.dispatch('showHeader',true);
    },
  methods : {
      async getData(){
        let promises = [];
        // promises.push(ApiService.getConcoursApi().getCards(ApiAuthenticationService.getCurrentUser().id,1).then((data) => {
        //   this.lastContest = data;
        //   this.showLastContest = !!this.lastContest.data.length;
        //   this.lastContest = this.lastContest.data[0];
        //   if (this.lastContest.image){
        //     this.cardChallengeMedia = this.lastContest.image.id !== undefined ? this.lastContest.image.id : '';
        //   } else {
        //     this.cardChallengeMedia = null;
        //   }
        // }));
        promises.push(ApiService.getConcoursApi().getCards(ApiAuthentificationService.getCurrentUser().id,20).then((data) => {
          if (data.data.length > 0) {
            this.lastContests = [];

            for (let i = 0; i < 20; i++) {
              if (data.data[i] !== undefined) {
                let contest = data.data[i];

                contest.challengeMedia = data.data[i].image ? data.data[i].image.id : '';

                this.lastContests.push(contest);
              }
            }

            this.showLastContest = true;
          } else {
            this.showLastContest = false;
          }
        }));
        promises.push(ApiService.getChallengeApi().get(ApiAuthenticationService.getCurrentUser().id,1).then((data) => {
          this.lastChallenge = data;
          this.lastChallengeLoad = this.lastChallenge.data.length ? this.lastChallenge.data[0]:'';
          this.showLastChallenge = this.lastChallengeLoad.id;
        }));
        promises.push(ApiService.getChallengeApi().getCommercialsChallenges(ApiAuthenticationService.getCurrentUser().id,2).then((data) => {
          this.lastChallengesCommercials = data;
          this.lastChallengesCommercialsLoad = this.lastChallengesCommercials.data;
          if(this.lastChallengesCommercialsLoad.length > 0){
            this.showLastChallengesCommercialsOne = this.lastChallengesCommercialsLoad[0].id;
          }
          if(this.lastChallengesCommercialsLoad > 1){
            this.showLastChallengesCommercialsTwo = this.lastChallengesCommercialsLoad[1].id;
          }
        }));
        await Promise.all(promises);
      },
      reload(){
        this.isLoading = true;
        this.getData().then(() => this.isLoading = false);
      },
      async getModal(){
        if(this.getChallengeSelected){
          await ApiService.getProfilApi().getAcceptModal(this.getChallengeSelected).then((data) => {
            this.acceptedContest = data.data;
            this.acceptedContest = this.acceptedContest.data ? this.acceptedContest.data.modalAccepted : true;
            this.hideLaws = this.acceptedContest;
            if (this.hideLaws){
              this.$bvModal.hide('laws');
            } else {
              this.$bvModal.show('laws');
            }
            !this.acceptedContest ? this.showModalLaws() : '';
          });
        }
      },
      showModal() {
        this.$store.dispatch('setChallengeUpdated','');
        this.$root.$emit('bv::show::modal', 'form-challenge', '#btnShow');
      },      
      showModalMobile() {
        // this.$root.$emit('bv::show::modal', 'form-challenge', '#btnShowMobile');
      },      
      showModalLaws() {
        if (this.isMobile){
          this.$store.dispatch('showHeader',false);
        }
        this.$bvModal.show('laws');
        this.hideLaws = false;
      },      
      hideModalLaws() {
        if (this.isMobile){
          this.$store.dispatch('showHeader',true);
        }
        this.hideLaws = true;
        this.$bvModal.hide('laws');
      },           
    },
    watch : {
      'getChallengeSelected' : function (){
        this.getModal();
      },
    }, 

};
</script>
